import { memo, useEffect, useRef, useState } from 'react';

import s from './style.module.scss';
import { Display } from '@/components/Display/Display';
import { Popup } from 'antd-mobile';
import { changeHorizonDomIntoView } from '@/utils/Page';
import { moreSkillImg } from '@/utils/Page/constant';
import MyIcon from '@/components/MyIcon';
const SkillList = (props) => {
    const { skillList = [], curSkill = {}, themeColor = 1 } = props;
    const [visible, setVisible] = useState(false);
    const [showMore, setShowMore] = useState(false);
    const boxRef = useRef(null);

    useEffect(() => {
        const dom = boxRef.current;
        const isOverflowing = dom.offsetWidth < dom.scrollWidth;
        setShowMore(isOverflowing);
    }, [skillList]);
    const showMask = () => {
        setVisible(true);
    };
    const closeMask = () => {
        setVisible(false);
    };

    const changeScroll = (key) => {
        let dom = document.getElementById(key);
        if (!dom) {
            return false;
        }
        changeHorizonDomIntoView(dom, boxRef.current);
    };
    const handleSetCurSkill = (item, from = 'list') => {
        if (props.setCurSkill) {
            props.setCurSkill(item);
        }
        // if (from === 'mask') {
        //     changeScroll(item.ability_id);
        // }
        closeMask();
    };

    useEffect(() => {
        changeScroll(curSkill?.ability_id);
        props.setCurPlugin([]);
    }, [curSkill?.ability_id]);
    return (
        <div className={s['skill-box']}>
            <Popup
                bodyStyle={{
                    borderTopLeftRadius: '15px',
                    borderTopRightRadius: '15px',
                    minHeight: '40vh'
                }}
                visible={visible}
                onMaskClick={closeMask}
            >
                <div className={s['mask-wrap']}>
                    <div className={s['mask-title']}>
                        <span>全部技能</span>
                        <span className={s['icon-wrap']} onClick={closeMask}>
                            {/* <CloseOutline /> */}
                            <MyIcon type="icon-a-guanbi31"></MyIcon>
                        </span>
                    </div>
                    <div className={s['mask-list-box']}>
                        {skillList.map((item, index) => {
                            return (
                                <div className={s['mask-list-item']} key={index} onClick={() => handleSetCurSkill(item, 'mask')}>
                                    {item.ability_name}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </Popup>
            <div ref={boxRef} className={s['list-box']}>
                {skillList.map((item, index) => {
                    return (
                        <div
                            id={item.ability_id}
                            className={s['list-item']}
                            data-active={curSkill?.ability_id === item.ability_id}
                            key={index}
                            onClick={() => handleSetCurSkill(item)}
                        >
                            {item.ability_name}
                        </div>
                    );
                })}
            </div>
            <Display show={showMore}>
                <div onClick={showMask} className={s['more']}>
                    <img src={moreSkillImg[themeColor]} alt="" />
                </div>
            </Display>
        </div>
    );
};
export default memo(SkillList);
